<template>
    <div class="col-12 col-lg-6 g c">
        <div class="card card-body">
            <div class="form-group">
              <h5 for="">اكتب ما تريده</h5>
              <textarea class="form-control form-control-lg" name="" id="" v-model="prompt" placeholder="اكتب هنا..." rows="3"></textarea>
            </div>
            <div class="col-12 text-center g">
                <button class="btn btn-primary" @click="Go()">
                    إنشاء التقرير
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            prompt: ""
        }
    },
    created(){
        if(!checkPer("settings")){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
    },
    methods: {
        Go(){
            var g = this;
             $.post(api + '/user/general/kg/go', {
                jwt: this.user.jwt,
                prompt: g.prompt
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    $.post(api + '/user/students/list', {
                jwt: g.user.jwt,
                q: "",
                page: 1,
                perpage: 10000
            }).then(function(rx){
                    var win = window.open()
                    var html = `<script>
                    var students = ${JSON.stringify(rx.response)}
                    <` + `/script>`;
                    html = html + r.response.split("```html")[1].split("```")[0]
                    win.document.write(html)
                    win.document.close()
            })
                }
            }).fail(function(){
                alert("حدث خطأ في الاتصال", 200)
            })
        }
    }
}
</script>

<style>

</style>